import { render, staticRenderFns } from "./DeepSeekChat.vue?vue&type=template&id=6cdd1e9e&"
import script from "./DeepSeekChat.vue?vue&type=script&lang=js&"
export * from "./DeepSeekChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports